import React, { useState } from "react";
import { Link } from "react-router-dom";
import Logo from "../../Assets/images/brown-logo.svg";
import styles from "./login.module.css";
import PrimaryButton from "../../Components/Buttons/PrimaryButton";
import showPassIcon from "../../Assets/images/eye-on.svg";
import hidePassIcon from "../../Assets/images/eye-off.svg";

const Resetpassword = () => {
	const [showPassword, setShowPassword] = useState(false);
	// const [error, setError] = useState("");
	// const [passwordError, setPasswordError] = useState("");

	// const validatePassword = (password) => {
	// 	const passwordRegex =
	// 		/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
	// 	return passwordRegex.test(password);
	// };

	return (
		<>
			<div className={styles.loginWrapper}>
				<div className={styles.loginCard}>
					<Link to="/" className={styles.formLogo}>
						<img src={Logo} alt="Natureland" />
					</Link>
					<form>
						<div className={styles.formHeader}>
							<h1>Reset Password</h1>
						</div>
						<div className="formElements">
							<div className="formGroup">
								<label className="formLabel">
									New Password
								</label>
								<div className={styles.inputGroup}>
									<input
										className={`${styles.formControl} form-control`}
										type={
											showPassword ? "text" : "password"
										}
										placeholder="Enter Password"
										// value={password}
										// onChange={(e) =>
										// 	setPassword(e.target.value)
										// }
										required
									/>
									<span
										className={styles.showIcon}
										onClick={() =>
											setShowPassword(!showPassword)
										}>
										<img
											src={
												showPassword
													? hidePassIcon
													: showPassIcon
											}
											alt="Toggle visibility"
										/>
									</span>
								</div>
								<ul className={styles.passwordCriteria}>
									<li>✅ One lowercase character</li>
									<li>✅ One uppercase character</li>
									<li>✅ One number</li>
									<li>✅ One special character</li>
									<li>✅ 8 characters minimum</li>
								</ul>
							</div>
							<div className="formGroup">
								<label className="formLabel">
									Confirm New Password
								</label>
								<div className={styles.inputGroup}>
									<input
										className={`${styles.formControl} form-control`}
										type="password"
										placeholder="Enter Password"
									/>
									<span className={styles.showIcon}>
										<img src={showPassIcon} alt="icon" />
									</span>
								</div>
							</div>
							<PrimaryButton
								text="Login"
								type="submit"
								className={styles.AuthButton}
							/>
							<div className={styles.bottomLink}>
								<Link
									to="/forgotpassword"
									className={styles.linkText}>
									Forgot your password?
								</Link>
							</div>
						</div>
					</form>
				</div>
			</div>
		</>
	);
};

export default Resetpassword;
